import { OrderedMap } from 'immutable';

import type { LiveStreamEntries } from '../types';

import { createEntityMapHandler } from 'app/lib/redux/applyEntities';
import { createStringFieldSequencer } from 'app/lib/sequencers';
import type { InitAction } from 'app/redux/actions/init';

import type { ApplyLiveStreamEntries } from '../actions';
import { APPLY_LIVE_STREAM_ENTRIES } from '../actions';
import type { RecordOfLiveStreamEntry } from '../records';
import { liveStreamEntry } from '../records';

// ---

type EntriesActions =
  | InitAction
  | ApplyLiveStreamEntries;

export const initialState: LiveStreamEntries = OrderedMap();

// ---

const applyEntries = createEntityMapHandler<
  LiveStreamEntries,
  RecordOfLiveStreamEntry,
  typeof liveStreamEntry
>('matchId', liveStreamEntry);

const orderByMatchName = createStringFieldSequencer(
  (match: RecordOfLiveStreamEntry) => match.matchName,
);

export default function (
  state = initialState,
  action: EntriesActions,
): LiveStreamEntries {
  switch (action.type) {
    case APPLY_LIVE_STREAM_ENTRIES:
      const newState = applyEntries(state, action.payload);

      if (newState !== state) {
        return newState.sort(orderByMatchName);
      }

      return state;

    default:
      return state;
  }
}
